export type SystemRole =
  | 'system_admin'
  | 'system_engineering_manager'
  | 'system_engineer'
  | 'system_support'
  | 'user';

const ENGINEER_PRIVILEGE_ROLES = new Set<string>([
  'system_admin',
  'system_engineer',
  'system_engineering_manager',
]);

const SUPPORT_PRIVILEGE_ROLES = new Set<string>([
  'system_admin',
  'system_support',
  'system_engineering_manager',
]);

const SUPPORT_STAFF_ROLES = new Set<string>([
  'system_admin',
  'system_engineering_manager',
  'system_engineer',
  'system_support',
]);

const ROLE_LABELS: Record<string, string> = {
  system_admin: 'System Admin',
  system_engineering_manager: 'Engineering Manager',
  system_engineer: 'System Engineer',
  system_support: 'System Support',
  user: 'User',
};

export const isSystemAdmin = (role?: string | null): boolean => role === 'system_admin';

export const hasEngineerPrivileges = (
  role?: string | null,
): boolean => Boolean(role && ENGINEER_PRIVILEGE_ROLES.has(role));

export const hasSupportPrivileges = (
  role?: string | null,
): boolean => Boolean(role && SUPPORT_PRIVILEGE_ROLES.has(role));

export const isSupportStaff = (role?: string | null): boolean => Boolean(role && SUPPORT_STAFF_ROLES.has(role));

export const receivesGlobalSupportAlerts = (role?: string | null): boolean => hasSupportPrivileges(role) || role === 'support';

export const getSystemRoleLabel = (role?: string | null): string => (role && ROLE_LABELS[role]) || 'User';
